//  Announcement Bar Js
  document.addEventListener('DOMContentLoaded', function () {
    const marqueeContent = document.querySelector('.marquee-content');
    if (marqueeContent) {
      const contentWidth = marqueeContent.scrollWidth / 2; 
      const containerWidth = marqueeContent.parentElement.offsetWidth;
      const speed = Math.max(10, (contentWidth / containerWidth) * 20); 

      marqueeContent.style.animationDuration = speed + 's';
    }
  });

// Hotspot section Ja
   document.querySelectorAll('.hotspot-toggle').forEach(function (btn) {
  btn.addEventListener('click', function () {
    let parent = btn.closest('.hotspot');
    let content = parent.querySelector('.hotspot-content');
    let plusIcon = parent.querySelector('.hotspot-plus');
    let closeIcon = parent.querySelector('.hotspot-close');

    // Close all other hotspots first
    document.querySelectorAll('.hotspot').forEach(function (hs) {
      if (hs !== parent) {
        hs.querySelector('.hotspot-content').classList.add('hidden');
        hs.querySelector('.hotspot-plus').classList.remove('hidden');
        hs.querySelector('.hotspot-close').classList.add('hidden');
      }
    });

    // Toggle the clicked one
    content.classList.toggle('hidden');
    plusIcon.classList.toggle('hidden');
    closeIcon.classList.toggle('hidden');
  });
});


// Footer link menu
document.addEventListener("DOMContentLoaded", function () {
  const toggles = document.querySelectorAll("footer .menu_items_link");

  toggles.forEach(toggle => {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation(); // stop link navigation

      const submenu = this.closest(".menu__item").querySelector(".submenu");
      const isOpen = submenu.classList.contains("open");

      if (isOpen) {
        submenu.classList.remove("open");
        this.setAttribute("aria-expanded", "false");
      } else {
        submenu.classList.add("open");
        this.setAttribute("aria-expanded", "true");
      }
    });
  });
});

// Collection filter 
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tab-filter-button');
    const seeAllButton = document.querySelector('.tab-filter-button.see-all');
    // const items = document.querySelectorAll('[data-category]');
    const facetInputsComponent = document.querySelector('facet-inputs-component');

   
    function clearActiveTabs() {
      
      tabs.forEach(t => t.classList.remove('active'));
      
    }

    
    tabs.forEach(tab => {
      if (tab === seeAllButton) return;

      tab.addEventListener('click', function () {
        clearActiveTabs();
        tab.classList.add('active');

        const filter = tab.dataset.filter;

        // items.forEach(item => {
        //   if (filter === 'all' || item.dataset.category === filter) {
        //     item.style.display = '';
        //   } else {
        //     item.style.display = 'none';
        //   }
        // });

        
        if (facetInputsComponent) {
          facetInputsComponent.dispatchEvent(new Event('change'));
        }
        
      });
    });

   
   
      seeAllButton.addEventListener('click', function () {
        clearActiveTabs();
        seeAllButton.classList.add('active');

       
        // items.forEach(item => {
        //   item.style.display = '';
        // });

        
        const checkboxes = document.querySelectorAll('.facets__pill-input');
        checkboxes.forEach(cb => cb.checked = false);

        if (facetInputsComponent) {
          facetInputsComponent.dispatchEvent(new Event('change'));
        }

         
      });
  
  });



 // Function to wrap text after '|' in span and remove '|'
function wrapBundleTitle() {
    const bundleTitles = document.querySelectorAll('.bundle-product-title');
    bundleTitles.forEach(title => {
        if (!title.dataset.processed) { 
            const parts = title.textContent.split('|');
            if (parts.length > 1) {
                title.innerHTML = `${parts[0].trim()} <span>${parts[1].trim()}</span>`;
            }
            title.dataset.processed = "true"; 
        }
    });
}

window.addEventListener('load', wrapBundleTitle);


const observer = new MutationObserver(() => {
    wrapBundleTitle();
});

observer.observe(document.body, { childList: true, subtree: true });


document.addEventListener('DOMContentLoaded', () => {
  const filters = document.querySelectorAll('.bundle-filter');
  const cards = document.querySelectorAll('.bundle-card');

  filters.forEach((filter) => {
    filter.addEventListener('click', () => {
      filters.forEach((f) => f.classList.remove('active'));
      filter.classList.add('active');

      const value = filter.dataset.filter;

      cards.forEach((card) => {
        if (value === 'all' || card.dataset.filter === value) {
          card.style.display = 'block';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });
});



  document.addEventListener('DOMContentLoaded', function () {
    // Get current page path (without domain)
    var currentPath = window.location.pathname;

    document
      .querySelectorAll('.monitor-display-bundle-wrapper a')
      .forEach(function (link) {
        var linkPath = link.getAttribute('href');

        // Exact match
        if (linkPath === currentPath) {
          link.classList.add('active');
        }
      });
  });